import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';

import {withStyles} from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import {Search} from 'material-ui-icons';


import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles';

import TextField from 'material-ui/TextField';

import PlayerList from "./components/PlayerList";
import PlayerHeader from "./components/PlayerHeader";
import ChartOptions from "./components/ChartOptions";

import HockeyShotChart from "./components/HockeyShotChart";

import * as actions from './redux/actions';
import logo from './images/icon.png';
import bnl from './images/bnl-logo.svg';

import './App.css';
import StatsContainer from "./components/StatsContainer";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    height: '100vh',
    [theme.breakpoints.up('md')]: {
      overflow: 'hidden',
    },
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100%'
    },
  },
  appBar: {
    background: 'linear-gradient(45deg, #2980b9 30%, #303030 90%)',
    position: 'absolute',
    fontSize: '26px',
    zIndex: theme.zIndex.navDrawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 10,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    backgroundColor: '#f1f1f1',
    height: '100%',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      width: 0
    },
    [theme.breakpoints.up('sm')]: {
      width: 66
    }
  },
  drawerInner: {
    width: drawerWidth,
    flexGrow: 1,
    height: 'calc(100%)',
    overflow: 'auto'
  },
  drawerHeader: {
    marginTop: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 10px',
    backgroundColor: '#303030',
    ...theme.mixins.toolbar,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: '100%',
    fontSize: '12px'
  },
  content: {
    width: '100%',
    minWidth: '300px',
    flexGrow: 1,
    backgroundColor: '#fff',
    padding: 12,
    height: 'auto',
    marginTop: 56,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      padding: 18,
    },
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 64,
      padding: 24,
    }
  },
  controls: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    [theme.breakpoints.up('sm')]: {
      right: '14px',
      top: '14px',
    }
  },
  footer: {
    height: 56,
    backgroundColor: '#222',
    width: '100%'
  },
  flex: {
    flex: 1,
  },
  searchIcon: {
    marginBottom: '-5px',
    marginTop: '-5px',
    height: '18px'
  }
});

const mql = window.matchMedia(`(min-width: 960px)`);

const colors = {
  "50": "#7ab2d7",
  "100": "#7ab2d7",
  "200": "#7ab2d7",
  "300": "#7ab2d7",
  "400": "#7ab2d7",
  "500": "#2980b9",
  "600": "#2980b9",
  "700": "#2980b9",
  "800": "#2980b9",
  "900": "#2980b9",
  "A100": "#7ab2d7",
  "A200": "#7ab2d7",
  "A400": "#7ab2d7",
  "A700": "#7ab2d7",
  "contrastDefaultColor": "light"
};

const theme = createMuiTheme({
  palette: {
    primary: colors,
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif'
  },
  shadows: []
});

const darkTheme = createMuiTheme({
  palette: {
    primary: {
      ...colors,
      "contrastDefaultColor": "dark"
    },
    type: 'dark',
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif'
  }
});

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mql: mql,
      docked: false,
      open: false
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
    this.setState({mql: mql, docked: mql.matches});
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged() {
    this.setState({
      mql: mql,
      docked: this.state.mql.matches,
      open: false
    });
  }

  toggleDrawerOpen = () => {
    this.setState({open: !this.state.open});
  };

  onPlayerChange(player) {
    this.props.selectPlayer(player);
    if (!this.state.docked) {
      this.setState({open: false});
    }
  }

  onPlayerFilterChange(event) {
    this.props.setPlayerFilter(event.target.value);
  }

  render() {
    const classes = this.props.classes;

    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <div className={classes.appFrame}>

            <AppBar elevation={0}
                    className={classNames(classes.appBar, this.state.docked && this.state.open && classes.appBarShift)}>
              <Toolbar>
                <img src={logo} className="App-logo" alt="logo" onClick={this.toggleDrawerOpen}/>
                <div className={classes.flex}>
                  <span style={{fontWeight: 300}}>HOCKEY</span><span style={{fontWeight: 700}}>DATA</span>
                </div>
                <Hidden mdUp>
                  <div className={classes.controls}>
                    <ChartOptions
                      shotType={this.props.shotType}
                      shotsFiltered={this.props.shotsFiltered}
                      onFilterChange={this.props.selectShotsFiltered}
                      onTypeChange={this.props.selectShotType}/>
                  </div>
                </Hidden>
                <Hidden smDown>
                  <a href="http://bnlconsulting.com" target="_blank" rel="noopener noreferrer">
                    <img src={bnl} className="App-bnl-logo" alt="bnl logo"/>
                  </a>
                </Hidden>
              </Toolbar>
            </AppBar>

            <Drawer
              type={this.state.docked ? 'permanent' : 'temporary'}
              ModalProps={{keepMounted:true}}
              classes={{paper: classNames(classes.drawerPaper, this.state.docked && !this.state.open && classes.drawerPaperClose)}}
              onRequestClose={this.toggleDrawerOpen}
              open={this.state.open}>
              <div className={classes.drawerInner} seamless="seamless" id='drawer'>
                <MuiThemeProvider theme={darkTheme}>
                  <div className={classes.drawerHeader}>
                    <TextField
                      id="search"
                      label={<span><Search className={classes.searchIcon}/> Player Search</span>}
                      type="search"
                      className={classes.textField}
                      onChange={this.onPlayerFilterChange.bind(this)}
                      value={this.props.playerFilter}
                      defaultValue={this.props.playerFilter}
                      margin="dense"
                    />
                  </div>
                </MuiThemeProvider>
                <PlayerList
                  players={this.props.playersList}
                  onClick={this.onPlayerChange.bind(this)}
                />
              </div>
            </Drawer>

            <main className={classes.content}>
              <Grid container spacing={24} className={classes.grid}>
                <Grid item xs={12} md={5} lg={6}>
                  <Grid container spacing={24} className={classes.grid}>
                    <Grid item xs={12}>
                      <PlayerHeader player={this.props.player}/>
                    </Grid>
                    <Hidden smDown>
                      <Grid item xs={12}>
                        <StatsContainer stats={this.props.playerStats}/>
                      </Grid>
                    </Hidden>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={7} lg={6}>
                  <Grid container spacing={24} className={classes.grid}>
                    <Grid item xs={12}>
                      <HockeyShotChart
                        data={this.props.playerShots}
                        shotType={this.props.shotType}
                        shotsFiltered={this.props.shotsFiltered}/>
                      <Hidden smDown>
                        <div style={{position: 'absolute', right: 24, top: 90}}>
                          <ChartOptions
                            shotType={this.props.shotType}
                            shotsFiltered={this.props.shotsFiltered}
                            onFilterChange={this.props.selectShotsFiltered}
                            onTypeChange={this.props.selectShotType}/>
                        </div>
                      </Hidden>
                    </Grid>
                    <Hidden mdUp>
                      <Grid item xs={12}>
                        <StatsContainer stats={this.props.playerStats}/>
                      </Grid>
                    </Hidden>
                    <Hidden mdUp>
                      <div className={classes.footer}>
                        <a href="http://bnlconsulting.com" target="_blank" rel="noopener noreferrer">
                          <img src={bnl} className="App-bnl-footer" alt="bnl logo"/>
                        </a>
                      </div>
                    </Hidden>
                  </Grid>
                </Grid>
              </Grid>
            </main>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    player: store.selected.player,
    color: store.selected.color,
    shotType: store.selected.shotType,
    shotsFiltered: store.selected.shotsFiltered,
    playerFilter: store.players.filterText,
    playersLoading: store.players.loading,
    playersList: store.players.list,
    playerStats: store.stats.data,
    playerShots: store.shots.data
  }
}

function mapDispatchToProps(dispatch) {
  const act = bindActionCreators(actions, dispatch);

  return {
    selectShotsFiltered: act.selectShotsFiltered,
    selectShotType: act.selectShotType,
    selectPlayer: act.selectPlayer,
    setPlayerFilter: act.setPlayerFilter
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/App.js